import { SR_API_ACTION_GET_USER_BY_PHONE } from 'api/actionTypes';

export default async function getUserByPhone({ state, apiClient }, phone) {
  const result = await apiClient.postWithState({
    action: SR_API_ACTION_GET_USER_BY_PHONE,
    state: state,
    payload: {
      phone: phone,
    },
    onSuccess(user) {
      state.set(['admin', 'user'], user);
      return user;
    },
  });

  return result;
}
